import { call } from '@advanza/api'
import { AppThunkAction } from 'hooks/hooks'

const invalidateReclaims = (dispatch: (action: { type: string }) => void): void => {
    dispatch({ type: 'INVALIDATE_RECLAIMS' })
    dispatch({ type: 'INVALIDATE_MATCHES' })
    dispatch({ type: 'INVALIDATE_PHONECLICKS' })
}

export const undoReclaimRequest =
    (leadId: number, leadType: 'match' | 'phone' = 'match'): AppThunkAction<Promise<void>> =>
    (dispatch) => {
        return call(`office/reclaims/undo-reclaim-request/${leadId}/${leadType}`).then(() => {
            dispatch({ type: 'INVALIDATE_RECLAIMS' })
            dispatch({
                type: leadType === 'match' ? 'INVALIDATE_MATCHES' : 'INVALIDATE_PHONECLICKS',
            })
        })
    }

type AnswerReclaimOptions = {
    date?: Date | string | null
    alt?: boolean
}

export const answerReclaim =
    (
        id: number,
        answer: string,
        reason: string,
        options: AnswerReclaimOptions = {},
    ): AppThunkAction<Promise<void>> =>
    (dispatch, getState) => {
        // The reclaim may not be in the reclaims store when answered from the matches/phone-clicks list.
        const reclaim = getState().reclaims.entities.reclaims?.[id]
        if (reclaim?.accepted) {
            return Promise.resolve()
        }
        return call(`office/reclaims/answer-reclaim-request/${id}/${answer}`, {
            json: { reason: reason, ...options },
        }).then(() => {
            invalidateReclaims(dispatch)
            return Promise.resolve()
        })
    }

/** CS admin override: withdraw a reclaim regardless of its current state or request status. Reason is mandatory. */
export const withdrawReclaimAdmin =
    (reclaimId: number, reason: string): AppThunkAction<Promise<void>> =>
    (dispatch) =>
        call(`office/reclaims/withdraw-reclaim/${reclaimId}`, { json: { reason } }).then(() => {
            invalidateReclaims(dispatch)
            return Promise.resolve()
        })

/** CS admin override: approve a reclaim regardless of its current state. Reason is mandatory. */
export const overrideApproveReclaim =
    (reclaimId: number, reason: string): AppThunkAction<Promise<void>> =>
    (dispatch) =>
        call(`office/reclaims/override-approve-reclaim/${reclaimId}`, { json: { reason } }).then(
            () => {
                invalidateReclaims(dispatch)
                return Promise.resolve()
            },
        )

/** CS admin override: soft-delete a reclaim into the visible "deleted" state. Reason is mandatory. */
export const deleteReclaim =
    (reclaimId: number, reason: string): AppThunkAction<Promise<void>> =>
    (dispatch) =>
        call(`office/reclaims/delete-reclaim/${reclaimId}`, { json: { reason } }).then(() => {
            invalidateReclaims(dispatch)
            return Promise.resolve()
        })
